import { throttle } from 'throttle-debounce';
import FeedList from '@/components/GiftCommon/components/FeedList/index.vue';

import Api from '@/biz/api';
import ProcessData from '@/biz/processData';
import Utils from '@/common/utils';
import Errors from '@/common/errors';
import Report from '@/common/report';
import reportConfig from '@/config/report.config';
import Enums from '@/config/enums.config';
import errorConfig from '@/config/errors.config';

import Shake from '@/components/Shake/Shake.vue';
import HalfScreen from '@/components/HalfScreen/HalfScreen.vue';
import TitleTab from '@/components/TitleTab/TitleTab.vue';
import GameWish from '@/components/GameWish/GameWish.vue';
import PublicityDetail from '@/components/PublicityDetail/PublicityDetail.vue';
import Rule from '@/components/Rule/Rule.vue';
import BroadcastBox from '@/components/BroadcastBox/BroadcastBox.vue';
import AdPop from '@/components/AdPop/AdPop.vue';
import PopUp from '@/components/PopUp/PopUp.vue';
import Toast from '@/components/Toast/Toast.vue';
import Config from '@/config/act.config';

// 摇心愿40次后出现"休息一下"
const SHOW_RESET_THRESHOLD = 40;
const NEED_REST_KEY = 'needRest';

export default {
  name: 'ShakeGift',
  components: {
    BroadcastBox,
    Shake,
    HalfScreen,
    TitleTab,
    GameWish,
    PublicityDetail,
    Rule,
    AdPop,
    FeedList,
    PopUp,
    Toast
  },
  data: function() {
    return {
      feedListConfig: {},
      isActive: true,
      reminderConfig: { isShow: false },
      curGameWishIndex: 0,
      halfScreenSlotType: '',
      openId: '',
      isForShake: false,
      shakeImageList: [],
      ruleConfig: [],
      openAppIdList: [],
      popUpConfig: {},
      adPopConfig: {},
      curTabType: 'wish',
      colorStyle: 'light',
      gameWishColorStyle: 'dark',
      halfScreenConfig: {},
      stageType: 0,
      shakeNormalConfig: {},
      titleTabConfig: [
        {
          type: 'wish',
          text: '我的心愿',
          isCur: true
        },
        {
          type: 'feed',
          text: '摇奖记录',
          isCur: false,
          redSpot: 0
        },
        {
          type: 'rule',
          text: '活动规则',
          isCur: false
        }
      ],
      gameWishList: [],
      gameWishTempItem: {
        isSelected: false,
        isDone: false,
        wishList: [
          {
            isDone: false
          },
          {
            isDone: false
          },
          {
            isDone: false
          }
        ]
      },
      broadcastList: [],
      toastConfig: {},
      needTakeRest: false,
      videoNumberId: '',
      isStrongReminder: false, // 是否显示强提醒（摇出奖励后回来显示）
      // 2023
      // 专场类型
      animationType: 'all',
      // 是否静音
      isMuted: false
    };
  },
  computed: {
    // 是否使用低电量
    // 用户进入微信时候就为低电量模式才会生效
    isUseOpenVideo() {
      return WXGAME.Env.isiOS && (window.__lowPowerMode__ || window.__lowPower__);
    }
  },
  methods: {
    // 获取游戏相关配置信息
    getActConfig() {
      return new Promise((resolve) => {
        Api.getSpringFestivalActConfig({
          req: {
            platid: WXGAME.Env.isAndroid ? 1 : 0
          }
        }).then((res) => {
          if (res.data && res.errcode === 0) {
            if (res.data.act_config) {
              let actConfig = res.data.act_config;

              this.actId = actConfig.act_id;
              this.ruleConfig = actConfig.rule;

              this.openId = actConfig.openid || '';

              this.stageType = actConfig.stage_type || 0;

              // 如果是只能许愿阶段，外抛事件
              if (this.stageType === Enums.STAGE_TYPE.ONLY_WISH) {
                this.$emit('only-wish');
              } else if (this.stageType === Enums.STAGE_TYPE.MOBA) {
                // 2023 新增各个专场赋值
                // 如果是专场，则变更animationType
                this.animationType = 'moba';
              } else if (this.stageType === Enums.STAGE_TYPE.PUBG) {
                // 如果是专场，则变更animationType
                this.animationType = 'pugb';
              } else if (this.stageType === Enums.STAGE_TYPE.DDZ) {
                // 如果是专场，则变更animationType
                this.animationType = 'ddz';
              } else if (this.stageType === Enums.STAGE_TYPE.LOLM) {
                // 如果是专场，则变更animationType
                this.animationType = 'lolm';
              } else if (this.stageType === Enums.STAGE_TYPE.MINI_GAME) {
                // 如果是专场，则变更animationType
                // 小游戏不做特殊专场，跟全流程一样
                this.animationType = 'all';
              }

              this.openAppIdList = actConfig.open_appid_list || [];

              this.timeSectionId = actConfig.current_time_section.section_id;

              this.sectionEndStamp = actConfig.current_time_section.end_time;

              // 重新赋值，满足vue的特性
              this.shakeNormalConfig = Object.assign({}, this.shakeNormalConfig);
            }

            // 摇一摇开合图
            if (res.data.shake_img_list) {
              this.shakeImageList = res.data.shake_img_list;
            }

            resolve(res);
          } else {
            this.$emit('load-error', { errorCode: res.errcode });
          }
          this.$emit('load-complete');
        });
      }).catch((res) => {
        if (res && typeof res === 'string' && res.search('401') > -1) {
          // 未授权状态
          location.replace(
            window.location.origin +
              window.location.pathname +
              '?path=shake_gift&nav_color=2B2265&darkmode_nav_color=2B2265&' +
              Config.globalQueries
          );
        } else {
          this.$emit('load-error', { errorCode: 1 });
          this.$emit('load-complete');
        }
      });
    },

    // 领取成功后更新气泡和提醒
    getGiftSuccessHandler() {
      setTimeout(() => {
        this.getMadeWishList();
        this.getReminder();
      }, 200);
    },

    // 获取气泡提醒
    getReminder() {
      Api.getspringfestivalreminder({
        req: {}
      }).then((res) => {
        if (res.errcode === 0) {
          if (res.data && res.data.reminder) {
            // 心愿池提醒
            this.reminderConfig = res.data.reminder;
            this.reminderConfig.isShow = true;
          } else {
            this.reminderConfig.isShow = false;
          }
        } else {
          this.reminderConfig.isShow = false;
        }
      });
    },

    // 查询已经许下的心愿
    getMadeWishList() {
      Api.getMySpringFestivalWish({
        req: {}
      }).then((res) => {
        if (res.data && res.errcode === 0) {
          // 转换字段
          this.gameWishList = ProcessData.gameWish(res.data.app_wish_list || []);
          this.titleTabConfig[1].redSpot = res.data.reward_ungot_num || 0;
        }
      });
    },

    // 获取广播数据
    getBroadcastList() {
      Api.getSpringFestivalBroadcast({
        req: {
          act_id: this.actId
        }
      }).then((res) => {
        if (res.data && res.errcode === 0) {
          this.broadcastList = res.data.feed_list || [];
        } else {
          this.popUpConfig = Utils.alertError(
            Errors.getMessage(res.errcode),
            res.errcode,
            res.errmsg
          );
        }
      });
    },

    // 设置 feedList 参数
    setFeedListConfig() {
      this.feedListConfig = {
        actid: this.actId,
        reload: Math.random()
      };
      this.feedListConfig = Object.assign({}, this.feedListConfig);
    },

    // 设置默认的 ad pop
    showDefaultAdPop() {
      this.adPopConfig = {
        isShow: true,
        type: Enums.AD_POP_TYPE.DEFAULT,
        sloganImgUrl:
          'https://mmgame.qpic.cn/image/870bd1d10b967fa5428b5162cdb93875d559d99a2fd3ad1763970457d3c35f8c/0',
        owner: '微信游戏'
      };
    },

    // 监听 shake 组件冒出的准备摇动事件
    readyForShakeHandler() {
      // 清除页面的无关信息
      this.isForShake = true;

      // 原有广告信息消除
      this.adPopConfig = {};

      // 2023 暂停背景音
      this.pauseBgSound();

      // 播放摇动音效
      this.playShakeSound();
    },

    // 监听 shake 组件冒出的请求事件
    shakeHandler() {
      // 是否进入休息一下逻辑
      if (this.needTakeRest) {
        this.needTakeRest = false;
        // 进入休息一下
        this.openRestPage();
      } else {
        // 正常摇动
        this.getShakeResult();
      }

      // 恢复相关信息的显示
      this.isForShake = false;
    },

    // 向上层传递活动状态（内测，活动结束等等）
    emitActTimeSection(res) {
      let actConfig = res.data.act_config || {};
      let timeSectionList = actConfig.time_section_list;
      let timeSection;
      timeSectionList.forEach((item) => {
        if (item.is_current) {
          timeSection = item;
        }
      });

      if (timeSection?.is_current) {
        // 该页面内测开启时不展示公示
        if (timeSection.time_section_type !== Enums.TIME_SECTION_TYPE.BETA_OPEN) {
          this.$emit('have-act-status', {
            timeSection,
            openId: actConfig.openid,
            actId: actConfig.act_id,
            subscriptionId: actConfig.subscribe_id
          });
        } else {
          this.reportPageExposure();
        }
      } else {
        this.reportPageExposure();
      }
    },

    // 获取摇一摇结果
    getShakeResult() {
      Api.springFestivalShake({
        req: {
          // eventid:13,
          actid: this.actId,
          platid: WXGAME.Env.isAndroid ? 1 : 0,
          time_section_id: this.timeSectionId
        }
      })
        .then((res) => {
          if (res.data && res.errcode === 0) {
            // 摇心愿SHOW_RESET_THRESHOLD次后，下次显示休息一下
            if (res.data.shake_count !== 0 && res.data.shake_count % SHOW_RESET_THRESHOLD === 0) {
              this.needTakeRest = true;
            }
            if (
              res.data.eventid === Enums.SHAKE_EVENT_ID.AD_PIC ||
              res.data.eventid === Enums.SHAKE_EVENT_ID.AD_VIDEO
            ) {
              // 摇到图片广告或者 视频号广告
              // 在当前摇一摇界面显示
              let adItem = res.data.ad || {};
              this.showAdPop(adItem);

              if (adItem) {
                this.videoNumberId = adItem.content_id || 0;
                this.videoAppId = adItem.appid || '';
                this.eventId = res.data.eventid || 8;
                Report.batch10861({
                  actId: this.actId,
                  openId: this.openId,
                  appId: this.videoAppId,
                  pid: reportConfig.SHAKE.PID,
                  pos: reportConfig.SHAKE.POSITION.VIDEO_AD,
                  action: reportConfig.ACTION.EXPOSURE
                });
              }

              // 恢复摇动能力
              this.enableShake();
            } else if (res.data.eventid === Enums.SHAKE_EVENT_ID.WONDERFUL_VIDEO) {
              // 2023 摇出精彩视频
              // 操作同摇出奖励
              // 播放打开音效
              this.playOpenSound();

              //摇动完毕震动提示
              this.vibratePhone(200);

              setTimeout(() => {
                // 记录打开的是其他页面
                this.isOpenOtherPage = true;
                WXGAME.openUrl(res.data.wonderful_url);
              }, 300);
            } else {
              // 中奖了
              // 如果有心愿同步到游市集，则下次显示休息一下，跳转游市集
              if (res.data.wish_sync_to_mall) {
                this.needTakeRest = true;
                WXGAME.LocalStorage.setKeyValue(NEED_REST_KEY, 'true');
              }
              // 播放打开音效
              this.playOpenSound();

              //摇动完毕震动提示
              this.vibratePhone(200);

              setTimeout(() => {
                // 跳转到奖励结果页面
                this.openResultPage(res.data);

                this.$refs.normalShake.recoverGuide();
                this.playBgSound();
              }, 300);
            }
          } else {
            if (
              res.errcode === errorConfig.code.ERR_TIME_NOT_BEGIN ||
              res.errcode === errorConfig.code.ERR_TIME_END
            ) {
              // 内测已经结束或活动已经结束
              // 重新拉配置信息，抛出
              this.getActConfig().then((res) => {
                this.emitActTimeSection(res);
              });
            } else {
              this.showErrorPopup(res);
            }
          }
        })
        .catch((res) => {
          // 显示保底内容
          this.showDefaultAdPop();

          // 恢复摇动能力
          this.enableShake();
        });
    },

    // 对于跨时间段问题的错误码和普通错误码的处理
    showErrorPopup(res) {
      this.popUpConfig = Utils.alertError(Errors.getMessage(res.errcode), res.errcode, res.errmsg);

      // 页面其他操作中
      this.disableActive();
      if (
        res.errcode === errorConfig.code.ERR_TIME_SECTION_MINIGAME_NORMAL_ONE ||
        res.errcode === errorConfig.code.ERR_TIME_SECTION_DDZ_NORMAL_ONE ||
        res.errcode === errorConfig.code.ERR_TIME_SECTION_LOLM_NORMAL_ONE ||
        res.errcode === errorConfig.code.ERR_TIME_SECTION_PUBG_NORMAL_ONE ||
        res.errcode === errorConfig.code.ERR_TIME_SECTION_MOBA_NORMAL_ONE ||
        res.errcode === errorConfig.code.ERR_TIME_SECTION_ALLGAME_NORMAL_ONE
      ) {
        // 普通专场之前的切换
        // 此时打开半屏重新选择愿望

        this.popUpConfig.data.title = '今日专场已开启，去许下更多心愿吧';
        this.popUpConfig.data.btnList = [
          {
            btnText: '去许愿',
            btnOperation: 'backToMakeWish'
          }
        ];
      } else if (res.errcode === errorConfig.code.ERR_NO_WISH_CANNOT_SHAKE) {
        // 没有许愿，提示许愿
        this.popUpConfig.data.title = '要先许愿才可以摇心愿哦';
        this.popUpConfig.data.btnList = [
          {
            btnText: '去许愿',
            btnOperation: 'backToMakeWish'
          }
        ];
      } else if (res.errcode === errorConfig.code.ERR_TIME_ONLY_WISH) {
        // 未到摇一摇时段
        // 提示去许愿页
        this.popUpConfig.data.title = '摇一摇暂未开启，去许下更多心愿吧';
        this.popUpConfig.data.btnList = [
          {
            btnText: '去许愿',
            btnOperation: 'backToMakeWish'
          }
        ];
      } else {
        this.closePopUp();

        // 其他错误
        // 显示保底广告
        this.showDefaultAdPop();

        // 页面功能占用结束
        this.enableActive();

        // 恢复摇动能力
        this.enableShake();
      }
    },

    // 打开奖励页面
    openResultPage(params) {
      // 记录打开的是奖励页面
      this.isOpenGiftPage = true;

      let type = params.info.source_info.type;
      let openUrl = `${Config.jumpUrl.gift}?nav_color=FF7A5A&darkmode_nav_color=FF7A5A&s=1&c=1&type=${type}&appid=${params.appid}&token=${params.instance_id}&openid=${this.openId}#wechat_redirect`;
      WXGAME.openUrl(openUrl, { noticeid: 66043145, ssid: 8888 });
    },

    // 打开休息一下页面
    openRestPage() {
      this.isOpenOtherPage = true;
      let openUrl = `${Config.jumpUrl.gift}?nav_color=FF7A5A&darkmode_nav_color=FF7A5A&rest=1&jm=1&s=1&c=1&type=15&appid=wx62d9035fd4fd2059&token=1&actid=${this.actId}&openid=${this.openId}#wechat_redirect`;
      WXGAME.openUrl(openUrl, { noticeid: 66043145, ssid: 8888 });
    },

    // 显示广告浮层
    showAdPop(adItem) {
      // 图片广告：cover_img_url 图片广告url ，vedio_url 图片广告跳转url
      // 视频广告：vedio_url 视频广告跳转url ，video_cover_url 视频广告封面url，content_id 视频广告内容

      this.adPopConfig = {
        isShow: true,
        type: adItem.type,
        sloganImgUrl: adItem.slogan_img_url || '',
        promotionImgUrl: adItem.cover_img_url || '',
        promotionJumpUrl: adItem.video_url || adItem.vedio_url || '',
        videoUrl: adItem.content_id || '',
        videoCoverUrl: adItem.video_cover_url || '',
        videoJumpUrl: adItem.vedio_url || '',
        tailImgUrl: adItem.tail_pic_url || '',
        tailJumpUrl: adItem.tail_jump_url || '',
        owner: adItem.appname || ''
      };
    },

    // 点击底部按钮
    bottomBoxClickHandler() {
      // 消去强提示效果
      this.isStrongReminder = false;

      // 如果有待领取的奖励，则显示feed
      if (this.titleTabConfig[1].redSpot) {
        this.curTabType = 'feed';
        this.titleTabConfig.forEach((titleTabItem) => {
          titleTabItem.isCur = titleTabItem.type === this.curTabType;
        });
      } else {
        if (this.curTabType === 'wish') {
          // 上报
          Report.batch10861({
            actId: this.actId,
            openId: this.openId,
            pid: reportConfig.SHAKE.PID,
            pos: reportConfig.SHAKE.POSITION.MY_WISH,
            action: reportConfig.ACTION.EXPOSURE
          });
        }
        if (this.curTabType === 'rule') {
          // 上报
          Report.batch10861({
            actId: this.actId,
            openId: this.openId,
            pid: reportConfig.SHAKE.PID,
            pos: reportConfig.SHAKE.POSITION.TAB_RULE,
            action: reportConfig.ACTION.EXPOSURE
          });
        }
      }

      this.showTabHalfScreen();
      this.reminderConfig.isShow = false;

      // 上报
      Report.batch10861({
        actId: this.actId,
        openId: this.openId,
        pid: reportConfig.SHAKE.PID,
        pos: reportConfig.SHAKE.POSITION.BUTTON_COIN,
        action: reportConfig.ACTION.BUTTON_CLICK
      });
    },

    // 点击广告浮层中的按钮
    // 视频开始播放也承接在这里
    adPopBtnClickHandler(params) {
      let btnOperation = params.btnOperation;
      let url = params.url || '';

      switch (btnOperation) {
        case 'close':
          this.adPopConfig = { isShow: false };
          this.$refs.normalShake.recoverGuide();
          this.playBgSound();
          break;
        case 'linkContent':
          // 推广主体跳转

          if (!url) {
            break;
          }
          WXGAME.openUrl(url, {}, (res) => {
            Report.batch10861({
              actId: this.actId,
              openId: this.openId,
              appId: this.videoAppId,
              pid: reportConfig.SHAKE.PID,
              pos: reportConfig.SHAKE.POSITION.VIDEO_AD,
              action: reportConfig.ACTION.LINK,
              externInfo: {
                linktar:
                  this.eventId === Enums.SHAKE_EVENT_ID.AD_PIC
                    ? reportConfig.LINK_TARGET.VIDEO_ACTIVITY
                    : reportConfig.LINK_TARGET.VIDEO_AD,
                feed_id: this.videoNumberId
              }
            });
          });
          break;
        case 'linkMore':
          // 推广尾巴跳转
          if (!url) {
            break;
          }
          WXGAME.openUrl(url, {}, (res) => {
            Report.batch10861({
              actId: this.actId,
              openId: this.openId,
              appId: this.videoAppId,
              pid: reportConfig.SHAKE.PID,
              pos: reportConfig.SHAKE.POSITION.VIDEO_AD,
              action: reportConfig.ACTION.LINK,
              externInfo: {
                linktar: reportConfig.LINK_TARGET.GAME_CIRCLE
              }
            });
          });
          break;
        case 'videoPlay':
          Report.batch10861({
            actId: this.actId,
            openId: this.openId,
            appId: this.videoAppId,
            pid: reportConfig.SHAKE.PID,
            pos: reportConfig.SHAKE.POSITION.VIDEO_AD,
            action: reportConfig.ACTION.VIDEO_PLAY
          });
          break;
        default:
          break;
      }
    },

    // 点击半屏中的按钮
    halfScreenBtnClickHandler(param) {
      let btnOperation = param.btnOperation;

      switch (btnOperation) {
        case 'close':
          // 关闭半屏
          this.closeHalfScreen();

          // 页面功能占用结束
          this.enableActive();
          break;
        case 'know':
          // 关闭半屏
          this.closeHalfScreen();

          // 页面功能占用结束
          this.enableActive();
          break;
        default:
          break;
      }
    },

    // 点击半屏中的tab
    titleTabClickHandler(param) {
      let tabType = param.tabType;

      this.titleTabConfig.forEach((titleTabItem) => {
        titleTabItem.isCur = titleTabItem.type === tabType;
      });

      this.curTabType = tabType;

      switch (tabType) {
        case 'rule':
          // 上报
          Report.batch10861({
            actId: this.actId,
            openId: this.openId,
            pid: reportConfig.SHAKE.PID,
            pos: reportConfig.SHAKE.POSITION.TAB_RULE,
            action: reportConfig.ACTION.EXPOSURE
          });

          break;
        case 'feed':
          this.setFeedListConfig();
          break;
        case 'wish':
          // 上报
          Report.batch10861({
            actId: this.actId,
            openId: this.openId,
            pid: reportConfig.SHAKE.PID,
            pos: reportConfig.SHAKE.POSITION.MY_WISH,
            action: reportConfig.ACTION.EXPOSURE
          });
          break;
        default:
          break;
      }
    },

    // 点击游戏心愿
    gameWishItemClickHandler: throttle(400, function(e) {
      this.curGameWishIndex = Number(e.currentTarget.dataset.index);

      if (this.gameWishList[this.curGameWishIndex].isSelected) {
        // 游戏已经选择过
        // toast 提示不能更改了
        this.toastConfig = {
          isShow: true,
          strongText: '已许愿',
          text: '不能更改了哦'
        };
        // 关闭浮层
        setTimeout(() => {
          this.toastConfig = {
            isShow: false
          };
        }, 2000);
      } else {
        // 尚未选择游戏心愿
        this.openMakeGameWish();
      }
    }),

    // 跳转到选游戏心愿的许愿页面
    openMakeGameWish() {
      // 关闭半屏
      this.closeHalfScreen();

      // 直接跳转到对应的游戏心愿选择页
      let targetAppId = this.gameWishList[this.curGameWishIndex].appId;

      // 上报
      Report.batch10861({
        actId: this.actId,
        openId: this.openId,
        pid: reportConfig.SHAKE.PID,
        pos: reportConfig.SHAKE.POSITION.BUTTON_ADD_GAME_WISH,
        action: reportConfig.ACTION.LINK,
        appId: targetAppId,
        externInfo: { linktar: reportConfig.LINK_TARGET.MAKE_WISH }
      });

      let pickWishUrl =
        window.location.origin +
        window.location.pathname +
        '?path=pick_wish&appid=' +
        targetAppId +
        '&nav_color=FF7A5A&darkmode_nav_color=FF7A5A&' +
        Config.globalQueries;

      WXGAME.openUrl(pickWishUrl, { noticeid: 66043145, ssid: 8888, actid: this.actId });
    },

    // 显示tab半屏
    showTabHalfScreen() {
      this.halfScreenSlotType = 'tab';
      this.halfScreenConfig = {
        isShow: true,
        withClose: true,
        title: '心愿池',
        type: 'tab',
        slotType: 'tab'
      };

      // 页面其他操作中
      this.disableActive();

      // 如果当前就是 feed
      // 显示tab时候也刷新 feed
      if (this.curTabType === 'feed') {
        this.setFeedListConfig();
      }
    },

    // 正在其他操作中，摇动能力不激活
    disableActive() {
      this.isActive = false;
    },

    // 其他操作已完成，摇动能力激活
    enableActive() {
      this.isActive = true;
    },

    // 恢复可摇动
    enableShake() {
      this.$refs.normalShake.enableShake();
    },

    // 浮层按钮处理
    popUpBtnClickHandler(params) {
      let btnOperation = params.btnOperation;
      switch (btnOperation) {
        case 'close':
          this.closePopUp();

          // 页面功能占用结束
          this.enableActive();
          break;
        case 'goToGameCircle':
          this.closePopUp();
          this.goToGameCircle();
          break;
        case 'backToMakeWish':
          // 关闭当前浮层
          this.closePopUp();

          // 重新获取活动信息
          this.getActConfig().then((res) => {
            // 改为打开许愿半屏
            this.showTabWish();

            // 恢复摇动能力
            this.enableShake();
            this.$refs.normalShake.recoverGuide();
            this.playBgSound();
          });

          // 重新拉取许愿信息
          this.getMadeWishList();

          break;
        case 'notWishNow':
          this.closePopUp();

          // 恢复摇动能力
          this.enableShake();
          break;
        default:
          break;
      }
    },

    // 打开反馈页面
    goFeedBackHandler() {
      // 关闭半屏
      this.closeHalfScreen();

      WXGAME.openUrl(Config.jumpUrl.feedback);
    },

    // 点击 feed 中的游戏圈
    feedGoToGameCircleHandler() {
      // 关闭半屏
      this.closeHalfScreen();

      this.goToGameCircle();
    },

    // 打开游戏圈
    goToGameCircle() {
      // 上报
      Report.batch10861({
        actId: this.actId,
        openId: this.openId,
        pid: reportConfig.SHAKE.PID,
        pos: reportConfig.SHAKE.POSITION.BUTTON_GO_TO_CIRCLE,
        action: reportConfig.ACTION.LINK,
        externInfo: { linktar: reportConfig.LINK_TARGET.GAME_CIRCLE }
      });

      WXGAME.openUrl(Config.jumpUrl.gameCircle);
    },

    // 关闭当前页面
    closePage() {
      WXGAME.WxBridge.invoke('closeWindow', {}, () => {});
    },

    // 关闭浮层
    closePopUp() {
      this.popUpConfig = { isShow: false };
    },

    // 关闭半屏
    closeHalfScreen() {
      this.halfScreenConfig = { isShow: false };
    },

    // 显示我的许愿
    showTabWish() {
      this.showTabHalfScreen();

      //切换tab到 feed
      this.curTabType = 'wish';
      this.titleTabConfig.forEach((item) => {
        item.isCur = false;
      });
      this.titleTabConfig[0].isCur = true;
    },

    // 2023 新增
    // 页面onHide的处理
    pageHideHandler() {
      // 页面收到浮窗也会继续播放音乐
      // 志浩在所有情况下都暂停音乐
      this.pauseBgSound();

      // 如果广告打开，则暂停播放视频
      // 是否有视频本身会判断
      if (this.adPopConfig.isShow) {
        this.$refs.adPop.pauseVideo();
      }
    },

    // 页面 onShow 的处理
    pageShowHandler() {
      // 页面无其他操作
      // 避免重复执行
      this.pageShowStatus();
    },

    // 页面 onShow 的处理
    pageShowStatus() {
      if (this.halfScreenConfig.isShow) {
        // 从 feed 去领奖页面再跳回
        // 刷新feed列表
        this.setFeedListConfig();
      } else {
        this.enableActive();

        // 可以扭转打开状态
        if (this.isOpenGiftPage) {
          this.isOpenGiftPage = false;
          this.isStrongReminder = true;

          // 2023 调整
          this.$refs.normalShake.recoverGuide();
        }

        if (this.isOpenOtherPage) {
          this.isOpenOtherPage = false;
          // 2023 调整
          this.$refs.normalShake.recoverGuide();
        }
      }

      // 2023 调整
      // 因为所有情况下都暂停了
      // 所以所有情况下都恢复
      // 但是要区分打开广告的情况
      if (!this.adPopConfig.isShow) {
        this.playBgSound();
      } else {
        // 如果广告打开，则继续播放视频
        // 是否有视频本身会判断
        this.$refs.adPop.continuePlayVideo();
      }

      // 重新获取红点数据,已许下的心愿
      this.getMadeWishList();

      // 重新获取提醒气泡数
      this.getReminder();

      // 判断是否下次摇需要显示休息一下
      const needRest = WXGAME.LocalStorage.getKeyValue(NEED_REST_KEY);
      if (needRest) {
        this.needTakeRest = true;
        WXGAME.LocalStorage.delKeyValue(NEED_REST_KEY);
      }
    },

    // 播放摇动音效
    playShakeSound() {
      this.shakeSound.muted = this.isMuted;
      if (WXGAME.WxBridge) {
        WXGAME.WxBridge.invoke('getNetworkType', {}, (res) => {
          this.shakeSound.play();
        });
      } else {
        this.shakeSound.play();
      }
    },

    // 播放打开音效
    playOpenSound() {
      this.openSound.muted = this.isMuted;
      if (WXGAME.WxBridge) {
        WXGAME.WxBridge.invoke('getNetworkType', {}, (res) => {
          this.openSound.play();
        });
      } else {
        this.openSound.play();
      }
    },

    // 调用手机振动功能
    vibratePhone(duration) {
      navigator.vibrate = navigator.vibrate || navigator.webkitVibrate;
      if (navigator.vibrate) {
        navigator.vibrate(duration);
        console.log('vibrate');
      } else {
        console.log('该浏览器不支持振动功能');
      }
    },

    // 监测摇动
    bindShakeEvent() {
      //设备是否支持加速度监测
      if (window.DeviceMotionEvent) {
        //开始监控加速度
        window.addEventListener('devicemotion', (e) => {
          if (this.isActive && this.$refs.normalShake) {
            this.$refs.normalShake.motionHandler(e);
          }
        });
      }
    },

    // 2023 新增
    // 暂停背景音乐
    pauseBgSound() {
      this.bgSound.pause();
    },
    // 恢复播放背景音乐
    playBgSound() {
      this.bgSound.muted = this.isMuted;
      this.bgSound.play();
    },
    changeMuteStatus() {
      this.isMuted = !this.isMuted;
      if (this.bgSound) {
        this.bgSound.muted = this.isMuted;
        if (this.isMuted) {
          this.pauseBgSound();
        } else {
          this.playBgSound();
        }
      } else {
        if (!this.isMuted) {
          this.playBgSound();
        }
      }
    },
    reportPageExposure() {
      // 获得活动数据之后再上报
      Report.batch10861({
        actId: this.actId,
        openId: this.openId,
        pid: reportConfig.SHAKE.PID,
        pos: reportConfig.SHAKE.POSITION.PAGE,
        action: reportConfig.ACTION.EXPOSURE
      });
    }
  },
  mounted: function() {
    //增加鉴权
    WXGAME.WxBridge.verifyJsapi(WXGAME.WxBridge.apis.concat(['setNavigationBarColor']), function(
      res
    ) {
      WXGAME.WxBridge.invoke(
        'setNavigationBarColor',
        { color: Config.navBarColor.shake },
        () => {}
      );
      WXGAME.WxBridge.invoke('setPageTitle', { color: Config.navBarColor.shakeTitle }, (res) => {});
    });

    this.getActConfig().then((res) => {
      this.emitActTimeSection(res);

      // 获取已许心愿列表
      this.getMadeWishList();

      // 发送其他请求
      this.getBroadcastList();

      // 绑定监测
      this.bindShakeEvent();

      // 2023 新增
      if (this.isUseOpenVideo) {
        this.isMuted = true;
      } else {
        this.playBgSound();
      }
    });
    this.getReminder();

    // 媒体节点赋值
    this.shakeSound = this.$refs.shakeSound;
    this.openSound = this.$refs.openSound;
    this.bgSound = this.$refs.bgSound;
  },
  created() {
    this.isOpenGiftPage = false;
    this.isOpenOtherPage = false;
  }
};
